<div class="left">
  <button class="color-button" mat-stroked-button (click)="patientRegistrationService.back()">
    <i class="fas fa-arrow-circle-left fa-lg"></i>
  </button>
</div>
<div *ngIf="isLoading" class="loading">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
<div class="patientCreationEditionPage" *ngIf="!isLoading">
  <div class="patientEdition">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ "forms.updatePatientTitle" | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-patient-form [isFromRouting]="false" [isCreation]="false" [source]="source" [patient]="patient"></app-patient-form>
      </mat-expansion-panel>
      <mat-expansion-panel *ngFor="let related of relateds">
        <mat-expansion-panel-header>
          <mat-panel-title>{{
            ("forms.updateRelatedTitle" | translate) +
              " : " +
              related.name.family.join(" ").trim() +
              " " +
              related.name.given.join(" ").trim()
          }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-related-form
          [isFromRouting]="false"
          [isCreation]="false"
          [related]="related"
          style="display: flex; justify-content: center"
        ></app-related-form>
      </mat-expansion-panel>
      <button
        *ngIf="!addRelatedToExistingPatient && isPatientUnder18 && ('dashboard/relatedinvite' | isAuthorized : 'POST' | async) === true"
        class="mt-1 mb-1"
        mat-raised-button
        color="primary"
        (click)="addRelated()"
      >
        {{ "btn.addRelated" | translate }}
      </button>
      <mat-expansion-panel *ngIf="addRelatedToExistingPatient" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ "forms.createRelatedTitle" | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-related-form
          [patient]="patient"
          [isFromRouting]="false"
          [isCreation]="true"
          (referentAddedToPatient)="referentAddedToPatient($event)"
          style="display: flex; justify-content: center"
        ></app-related-form>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
